module.exports = __webpack_public_path__ + "media/sprite-1009c7f6.svg";